import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "message", "onDismiss", "link", "className", "htmlProps", "children"];
import cn from 'classnames';
import CloseSmall from '@crehana/icons/outline/CloseSmall';
import TextLink from "../Buttons/TextLink";
import parseClassnames from "../helpers/parseClassnames";
import { stateIconColors, stateIcons, stateTextColorClassNames } from "../styles/states";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Banner = function Banner(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'info' : _ref$type,
    message = _ref.message,
    onDismiss = _ref.onDismiss,
    link = _ref.link,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    htmlProps = _ref.htmlProps,
    children = _ref.children,
    bannerProps = _objectWithoutProperties(_ref, _excluded);
  var color = stateIconColors[type];
  var IconComponent = stateIcons[type];
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread(_objectSpread({
    className: parseClassnames(className, cn('px-24 py-8 border border-solid flex items-center', {
      'border-green-main bg-green-lighter': type === 'success',
      'border-yellow-main bg-yellow-lighter': type === 'warning',
      'border-red-main bg-red-lighter': type === 'alert',
      'border-purple-main bg-purple-lighter-2': type === 'info'
    }))
  }, bannerProps), htmlProps), {}, {
    children: [children || /*#__PURE__*/_jsxs("p", {
      className: cn('font-label flex-grow inline sm:flex items-center justify-center mr-12 sm:mr-0', stateTextColorClassNames[type]),
      children: [/*#__PURE__*/_jsx(IconComponent, {
        size: 16,
        ignoreColor: true,
        className: "flex-shrink-0 hidden mr-8 fill-current sm:block"
      }), message, ' ', link ? /*#__PURE__*/_jsx(TextLink, {
        type: "level2",
        label: link.text,
        href: link.url,
        onClick: link.onClick,
        className: cn('underline ml-4', {
          'text-green-main sm:hover:text-green-light': type === 'success',
          'text-yellow-main sm:hover:text-yellow-light': type === 'warning',
          'text-red-main sm:hover:text-red-light': type === 'alert',
          'text-purple-main sm:hover:text-purple-light': type === 'info'
        })
      }) : null]
    }), onDismiss && /*#__PURE__*/_jsx("button", {
      type: "button",
      onClick: onDismiss,
      className: "flex-shrink-0 outline-none",
      children: /*#__PURE__*/_jsx(CloseSmall, {
        size: 24,
        color: color
      })
    })]
  }));
};
export default Banner;